import CircularLoading from "./CircularLoading";

function LoadingPage() {
  return (
    <div className="w-full h-[60vh] flex items-center justify-center">
      <CircularLoading size={35} />
    </div>
  );
}

export default LoadingPage;